<template>
  <div>
    <component :is="modal.component"
               v-for="(modal, index) in modals"
               :key="index"
               v-bind="modal.props"
               @created="onCreated($event, modal.modalName)"
               @edited="onEdited($event, modal.modalName)"
               @deleted="onDeleted($event, modal.modalName)"
               @close="closeModal(index)" />
  </div>
</template>

<script>
export default {
  name: 'RegModalManager',
  data() {
    return {
      modals: []
    }
  },
  methods: {
    async openModal(modalName, props = {}) {
      let component
      switch (modalName) {
        case 'PartnerDetails':
          component = () => import('~pages/Finance/Partner/PartnerDetails.vue')
          break
        case 'ContractInstallmentDetails':
          component = () => import('~pages/Finance/Contract/ContractInstallmentDetails.vue')
          break
        case 'FinanceTransactionDetails':
          component = () => import('~pages/Finance/FinanceTransaction/FinanceTransactionDetails.vue')
          break
        case 'SearchTransactionsModal':
          component = () => import('~components/bank-reconciliation/SearchTransactionsModal.vue')
          break
        default:
          throw new Error(`Unknown modal name: ${modalName}`)
      }

      const alreadyOpened = this.modals.find(modal => modal.modalName === modalName)
      if (alreadyOpened) {
        return
      }

      const mergedProps = { ...props, routeDialog: false }
      this.modals.push({ component, modalName, props: mergedProps })
    },
    closeModal(index, modalName) {
      this.modals.splice(index, 1)
      this.$emit('close', modalName)
    },
    onCreated(item, modalName) {
      this.$emit('created', modalName, item)
    },
    onEdited(item, modalName) {
      this.$emit('edited', modalName, item)
    },
    onDeleted(item, modalName) {
      this.$emit('deleted', modalName, item)
    }
  }
}
</script>
